import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",

  "& .MuiOutlinedInput-root": {
    backgroundColor: "#ffffff",
    borderRadius: 6,

    "& fieldset": {
      borderColor: "#d1d5db",
    },

    "&:hover fieldset": {
      borderColor: "#9ca3af",
    },

    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
      borderWidth: 1.5,
    },

    "&.Mui-error fieldset": {
      borderColor: theme.palette.error.main,
    },
  },

  "& .MuiOutlinedInput-input": {
    padding: "12px 14px",
    fontSize: "0.95rem",
    color: "#111827",
  },

  "& .MuiInputLabel-root": {
    fontSize: "0.85rem",
    color: "#6b7280",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.palette.primary.main,
  },

  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    fontSize: "0.75rem",
  },
}));

const Textfield = React.forwardRef(function Textfield(props, ref) {
  const {
    id,
    name,
    label,
    placeholder,
    type = "text",
    variant = "outlined",
    value,
    onChange,
    onBlur,
    error = false,
    helperText,
    disabled = false,
    required = false,
    autoComplete = "off",
    ...rest
  } = props;

  const isDateTime =
    type === "date" ||
    type === "datetime-local" ||
    type === "time";

  return (
    <StyledTextField
      ref={ref}
      id={id}
      name={name}
      label={label}
      type={type}
      variant={variant}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      disabled={disabled}
      required={required}
      autoComplete={autoComplete}
      fullWidth
      helperText={error ? helperText : undefined}
      InputLabelProps={{
        shrink: isDateTime || Boolean(value),
      }}
      inputProps={{
        placeholder: placeholder,
      }}
      {...rest}
    />
  );
});

export default Textfield;
